"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationNoticeWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../commonFunctions");
var journey_services_1 = require("@ferry/journey-services");
var CancellationNoticeWidget = /** @class */ (function (_super) {
    __extends(CancellationNoticeWidget, _super);
    function CancellationNoticeWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.pageTitle = _this.getSetting("pageTitle", undefined);
        return _this;
    }
    CancellationNoticeWidget.prototype.render = function () {
        var journeyState = this.props.engine.getJourneyState();
        var firstName = journeyState["driverFirstName"];
        var lastName = journeyState["driverLastName"];
        var interaction = this.props.interaction;
        if (interaction) {
            if (interaction.process === journey_services_1.INTERACTION_PROCESS_MTA) {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "text-group", children: [(0, jsx_runtime_1.jsx)("h1", { children: this.pageTitle }), (0, jsx_runtime_1.jsxs)("p", { className: "text-white", children: ["Unfortunately we can't offer cover for ", firstName, " ", lastName, " due to changes you have made. We will continue to cover ", firstName, " ", lastName, " until ", (0, commonFunctions_1.convertDate)(interaction.headerInfo.endDate, "DD MMMM YYYY")] })] }));
            }
            else if (interaction.process === journey_services_1.INTERACTION_PROCESS_MTC) {
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "text-group", children: [(0, jsx_runtime_1.jsx)("h1", { children: this.pageTitle }), (0, jsx_runtime_1.jsx)("p", { className: "text-white", children: "Unfortunately we can't cover you anymore. Your car cover will be cancelled in 7 days." })] }) }));
            }
            else if (interaction.process === journey_services_1.INTERACTION_PROCESS_CHANGE_ADDRESS) {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "text-group", children: [(0, jsx_runtime_1.jsx)("h1", { children: this.pageTitle }), (0, jsx_runtime_1.jsxs)("p", { className: "text-white", children: ["Unfortunately we can't offer cover due to changes you have made. We will continue your cover until ", (0, commonFunctions_1.convertDate)(interaction.headerInfo.endDate, "DD MMMM YYYY")] })] }));
            }
            else {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            }
        }
        else {
            return null;
        }
    };
    return CancellationNoticeWidget;
}(plugin_journey_1.WidgetBase));
exports.CancellationNoticeWidget = CancellationNoticeWidget;
//# sourceMappingURL=CancellationNoticeWidget.js.map